import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'selector-item',
    templateUrl: './selector.component.html',
    providers: []
})
export class SelectorComponent implements OnInit {

    @Input() dto;
    @Input() invalid;
    @Input() invalidText;
    @Input() disabled;
    @Input() list;
    @Input() disableDefault;
    @ViewChild("selectorItem", {read: ElementRef}) child: ElementRef;
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    @Output() modelChange:EventEmitter<any> = new EventEmitter<any>();

    modelValue;
    default:number = 0;

    @Input()
    get model() {
        return this.modelValue;
    }

    set model(val) {
        this.modelValue = val;
    }

    changeEvent() {
        this.dto.pointOfSaleOid = this.modelValue;
        this.onChange.emit(this.modelValue);
    }

    ngOnInit(): void {
        this.modelValue = !!this.modelValue?this.modelValue:this.default;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additionalPoint/selector/selector.component.ts